// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_HUMANS = [{
  id: 'humans_rus',
  factionId: FACTIONS.HUMANS,
  name: 'Русич',
  priceNumens: 10000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN,
  ]
}, {
  id: 'humans_desert',
  factionId: FACTIONS.HUMANS,
  name: 'Дуэлянт Дюн',
  priceNumens: 25000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: 'humans_ink',
  factionId: FACTIONS.HUMANS,
  name: 'Вождь инков',
  priceNumens: 27000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.VIOLET,
  ]
}, {
  id: 'humans_key',
  factionId: FACTIONS.HUMANS,
  name: 'Братство ключа',
  priceNumens: 31000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: 'humans_tree',
  factionId: FACTIONS.HUMANS,
  name: 'Орден памяти',
  priceNumens: 33000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'humans_nomad',
  factionId: FACTIONS.HUMANS,
  name: 'Кочевник',
  priceNumens: 35000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE
  ]
}, {
  id: 'humans_china',
  factionId: FACTIONS.HUMANS,
  name: 'Шёлковый Император',
  priceNumens: 50000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.PINK,
  ]
}, {
  id: 'humans_north',
  factionId: FACTIONS.HUMANS,
  name: 'Северный медведь',
  priceNumens: 53000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.SKY_BLUE
  ]
}, {
  id: 'humans_samurai',
  factionId: FACTIONS.HUMANS,
  name: 'Даймё',
  priceNumens: 75000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.VIOLET,
  ]
}, {
  id: 'humans_grifon',
  factionId: FACTIONS.HUMANS,
  name: 'Орден грифона',
  priceNumens: 200000,
  skinRank: 3,
}, {
  id: 'humans_beta',
  factionId: FACTIONS.HUMANS,
  name: 'Крестоносец',
  notObtainable: true,
  priceNumens: 0,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'humans_alpha',
  factionId: FACTIONS.HUMANS,
  name: 'Паладин',
  notObtainable: true,
  priceNumens: 0,
  skinRank: 5,
  colors: [
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.INDIGO,
  ]
}, {
  id: 'humans_dev',
  factionId: FACTIONS.HUMANS,
  name: 'Спартанец',
  notObtainable: true,
  priceNumens: 0,
  skinRank: 5,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.VIOLET,
  ]
}, {
  id: 'humans_gold_legacy',
  factionId: FACTIONS.HUMANS,
  name: 'Центурион',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'humans_ruby_legacy',
  factionId: FACTIONS.HUMANS,
  name: 'Легат',
  priceCrystals: 250,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.VIOLET,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
